import $ from 'jquery';

export default class QuickNav {
    constructor() {
        // quick nav
        let $quickNav = $('.quick-nav');

        // locate each block
        let $blocks = $('.web-block.content-image-50');

        $blocks.each(function(i, block){
            let $block = $(block);
            if ($block.find('h4').length > 0 && $block.find('h4').text() != '') {
                let $navItem = $('<li>'+$block.find('h4').text()+'</li>');
                $navItem.click((e) => {
                    $('body,html').animate({ scrollTop: ( $block.offset().top - ($('header.banner').outerHeight() + 25 ) ) });

                    e.preventDefault();
                });
                $quickNav.find('ul').append($navItem);
            }
        });
    }
}

new QuickNav();